import {
  getIsPreOrder,
  getPurchaseStatus
} from '@/SearchResults/ResultTileV2/helpers/ResultTile.helpers';
import { useTileDataContext } from '~/contexts/TileDataContext';
import OnHoldTag from './OnHoldTag';
import Tag from '../Tag';

const StatusTags = () => {
  const { tileData } = useTileDataContext();
  const showPreOrderTag = getIsPreOrder(tileData);
  const { isLocked: showLockedTag, isOnHold: showOnHoldTag } =
    getPurchaseStatus(tileData);

  return (
    <div className="absolute flex gap-4 left-[8px] top-[8px]">
      {showOnHoldTag && <OnHoldTag />}
      {showPreOrderTag && (
        <Tag
          tag="reservable"
          text="Pre-Order Now"
          data-qa="text-only-reservable"
        />
      )}
      {showLockedTag && (
        <Tag
          tag="locked"
          text="Purchase in Progress"
          data-qa="text-only-locked"
        />
      )}
    </div>
  );
};

export default StatusTags;
